import React, { useContext, useEffect } from "react"
import { myContext } from "./provider"
import { graphql } from "gatsby"
import "./components/styles/reset.scss"
import "./components/styles/layout.scss"
import Header from "./components/header"
import SEO from "./components/seo"
import { MDXProvider } from "@mdx-js/react"
import PageTransition from "gatsby-plugin-page-transitions"
import {
  TranslatedTitle,
  ImageClipped,
  H1,
  Section,
  SocialMedias,
} from "./components/mdx-components"

export default data => {
  const context = useContext(myContext)
  useEffect(() => {
    context.setCurrentLanguage(data.pageContext.frontmatter.language)
    context.setTranslatedSlug(data.pageContext.frontmatter.slug.translated)
  }, [context, data.pageContext.frontmatter])

  const shortcodes = {
    TranslatedTitle,
    ImageClipped,
    H1,
    Section,
    SocialMedias,
  }
  return (
    <>
      <SEO
        title={data.pageContext.frontmatter.pageTitle}
        lang={data.pageContext.frontmatter.language}
      />
      <div className="right-side-darker"> </div>
      <Header />
      <PageTransition
        defaultStyle={{
          transition: "all 320ms ease-in-out",
        }}
        transitionStyles={{
          entering: { opacity: 0.2, transform: "translateY(0.2%)" },
          entered: { opacity: 1, transform: "translateY(0%)" },
        }}
      >
        <main>
          <MDXProvider components={shortcodes}>{data.children}</MDXProvider>
        </main>
      </PageTransition>
    </>
  )
}

export const pageQuery = graphql`
  query {
    allMdx {
      edges {
        node {
          frontmatter {
            date
            pageTitle
            menuTitle
            menuOrder
            slug {
              translated
            }
          }
        }
      }
    }
  }
`
